
import Vue from 'vue';
import { mapState } from 'vuex';
import ListItem from '@/components/base/ListItem.vue';
import Workspaces from '@/views/Workspaces/Workspaces.vue';
import InfoAssetBanner from '@/components/base/InfoAssetBanner.vue';

export default Vue.extend({
	name: 'SpacesList',
	metaInfo: {
		title: 'Spaces',
	},
	props: {
		currTeam: { type: Object, default: null },
		currTeamUserRole: { type: Object, default: null },
	},
	data () {
		return {};
	},
	computed: {
		...mapState([
			'user',
		]),
	},
	components: {
		InfoAssetBanner,
		ListItem,
		Workspaces,
	},
});
